import { HotelLastSecondHotelPagePropertiesTypes } from "@website/accommodation-ui/hotel-last-second/hotel-last-second-hotel-page/hotel-last-second-hotel-page.type";
import { HotelReserveCard } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";
import { HotelLastSecondDiscountBox } from "../hotel-last-second-new-design";

const Component: FC<HotelLastSecondHotelPagePropertiesTypes> = ({
  lastSecondRooms,
  hasMorContentButton,
  roomDetail,
  onInView,
  snappPayData
}) => {
  const lastSecondRoomsData = lastSecondRooms?.map((room) => ({
    ...room,
    regularBadges:
      room?.regularBadges?.filter((badge) => badge.type !== "last_minute") || []
  }));

  return (
    <div className="bg-transparent-primary border-transparent-primary mt-12 flex flex-col gap-4 border-y p-6 lg:mt-[124px] xl:mx-6 xl:mt-[78px] xl:rounded-xl xl:border">
      <HotelLastSecondDiscountBox size="medium" />
      <div className="flex flex-col gap-6">
        {lastSecondRoomsData?.map((room) => (
          <HotelReserveCard
            {...room}
            hasMorContentButton={hasMorContentButton}
            key={room.id}
            onClick={room.onClick}
            onInView={(inView) => onInView?.(inView, room)}
            roomDetail={roomDetail}
            snappPayData={snappPayData}
          />
        ))}
      </div>
    </div>
  );
};
export const HotelLastSecondHotelPage = memo(Component, deepCompare);
